import { render, staticRenderFns } from "./DescriptionSections.vue?vue&type=template&id=1832028a&"
import script from "./DescriptionSections.vue?vue&type=script&lang=js&"
export * from "./DescriptionSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports